import React  from 'react';
import {
  ProductsTable,
  SidebarWithHeader,
} from '../components';
import { HStack, VStack, Spinner, Heading, Button } from '@chakra-ui/react';
import { MdOutlineRefresh } from 'react-icons/md';
import { Link } from 'react-router-dom';
import { useProductContext } from '../context/product_context';

function ProductsPage() {
  
  const {
    products,
    products_loading: loading,
    products_error: error,
    fetchProducts,
  } = useProductContext();

  const handleRefresh = async () => {
    await fetchProducts();
  };

  

  if (loading) {
    return (
      <SidebarWithHeader>
        <HStack mb={5}>
          <Button as={Link} to='/products/new' colorScheme='brown'>
            Ajouter un nouveau produit
          </Button>
          <Button
            colorScheme='brown'
            variant='outline'
            leftIcon={<MdOutlineRefresh />}
            onClick={handleRefresh}
          >
            Refresh
          </Button>
        </HStack>
        <VStack alignItems='center' justifyContent='center'>
          <Spinner size='lg' color='brown.500' />
        </VStack>
      </SidebarWithHeader>
    );
  }

  if (error) {
    return (
      <SidebarWithHeader>
        <HStack mb={5}>
          <Button as={Link} to='/products/new' colorScheme='brown'>
            Ajouter un nouveau produit
          </Button>
          <Button
            colorScheme='brown'
            variant='outline'
            leftIcon={<MdOutlineRefresh />}
            onClick={handleRefresh}
          >
            Refresh
          </Button>
        </HStack>
        <VStack alignItems='center' justifyContent='center'>
          <Heading color='red.500'>There was an error</Heading>
        </VStack>
      </SidebarWithHeader>
    );
  }

  return (
    <SidebarWithHeader>
      <HStack mb={5}>
        <Button as={Link} to='/products/new' colorScheme='brown'>
          Ajouter un nouveau produit
        </Button>
        <Button
          colorScheme='brown'
          variant='outline'
          leftIcon={<MdOutlineRefresh />}
          onClick={handleRefresh}
        >
          Refresh
        </Button>
      </HStack>
      <ProductsTable products={products} />
    </SidebarWithHeader>
  );
}

export default ProductsPage;
